(() => {
  const init = () => {
    const shell = document.querySelector('[data-lura-header]');
    if (!shell || shell.dataset.bound) return;
    shell.dataset.bound = 'true';
    const toggle = shell.querySelector('.ls-menu-toggle');
    const nav = shell.querySelector('.ls-nav');
    const dialog = shell.querySelector('.ls-search');
    const searchButton = shell.querySelector('[data-lura-search]');
    const close = () => {
      nav.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false');
      shell.querySelectorAll('details').forEach(d => { d.open = false; });
    };
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      close(); nav.classList.toggle('is-open', open); toggle.setAttribute('aria-expanded', String(open));
    });
    shell.querySelectorAll('details').forEach(d => d.addEventListener('toggle', () => {
      if (d.open) shell.querySelectorAll('details').forEach(other => { if (other !== d) other.open = false; });
    }));
    nav.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
    searchButton.addEventListener('click', () => { close(); dialog.showModal(); shell.querySelector('#LuraSearchInput').focus(); });
    shell.querySelector('[data-lura-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => searchButton.focus());
    dialog.addEventListener('click', e => { const r=dialog.getBoundingClientRect(); if(e.target===dialog && (e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)) dialog.close(); });
    document.addEventListener('click', e => { if (!shell.contains(e.target)) close(); });
    shell.addEventListener('focusout', () => { requestAnimationFrame(() => { if (!shell.contains(document.activeElement)) close(); }); });
    document.addEventListener('keydown', e => {
      if(e.key!=='Escape'||dialog.open) return;
      const active=shell.querySelector('details[open] summary'); const mobile=nav.classList.contains('is-open');
      close(); if(active) active.focus(); else if(mobile) toggle.focus();
    });
    matchMedia('(min-width: 1101px)').addEventListener('change', close);
  };
  init(); document.addEventListener('shopify:section:load', init);
})();
